export function getSignUpUrl(webUrl: string): string {
	return `${webUrl}/users/sign-up`;
}
